import React from 'react';

import {stripUrlDecorations} from 'shared/lib/format/string';

import styles from '../HttpMonitorDetails.module.scss';

interface IHttpMonitorSectionTitleProps {
    title: string;
    name?: string;
}

const HttpMonitorSectionTitle: React.FC<IHttpMonitorSectionTitleProps> = ({title, name}) => (
    <div className={styles.titleBlock}>
        <h3 className={styles.title}>
            <span>{title}</span>
            <span className={styles.name}>
                {name && stripUrlDecorations(name)}
            </span>
        </h3>
    </div>
);

export default HttpMonitorSectionTitle;
